<template>
    <div class="home">
        <page-head></page-head>
        <div class="middle_content">
            <div class="content">
                <div class="left">
                    <div class="progress_title">操作流程</div>
                    <div class="progress">
                        <div class="item_progress">
                            <div class="img_icon">
                                <img src="../../assets//home/register.png" alt="">
                            </div>
                            <div class="desc">注册</div>
                        </div>
                        <div class="next_icon">
                            <i class="el-icon-arrow-right "></i>
                        </div>

                        <div class="item_progress">
                            <div class="img_icon">
                                <img src="../../assets//home/word.png" alt="">
                            </div>
                            <div class="desc">提交word版材料</div>
                        </div>
                        <div class="next_icon">
                            <i class="el-icon-arrow-right "></i>
                        </div>

                        <div class="item_progress">
                            <div class="img_icon">
                                <img src="../../assets//home/pdf.png" alt="">
                            </div>
                            <div class="desc">审核通过后，提交pdf版材料</div>
                        </div>
                        <div class="next_icon">
                            <i class="el-icon-arrow-right "></i>
                        </div>

                        <div class="item_progress">
                            <div class="img_icon">
                                <img src="../../assets//home/admin.png" alt="">
                            </div>
                            <div class="desc">管理员审核材料</div>
                        </div>
                    </div>
                    <div class="divider">

                    </div>
                    <div class="need_word">申请须知</div>
                    <!-- v-html="siteContent" -->

                    <div class="word_desc" v-html="siteContent">

                    </div>
                    <div class="more" v-if="siteContent" @click="lookMore">更多>></div>
                    <img src="../../assets/home/reactange.png" class="right_split" alt="">
                </div>
                <div class="right">
                    <div class="door">
                        <img src="../../assets/home/door.png" alt="">
                    </div>
                    <div class="register_btn" @click="toInfoRegister">首次使用系统，请先注册</div>
                    <div class="login_btn" @click="handleLogin">已注册用户登录</div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div>请使用谷歌、edge，或其他三方浏览器（360、搜狗等浏览器）的高速模式访问本系统</div>
            <div>四川大学继续教育学院</div>
        </div>
        <!-- 登录 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="" :show-close="false"
            custom-class="payDialog" :visible.sync="phoneVisible" width="450px">
            <div class="phone">
                <el-input @input="phoneInput" placeholder="请输入手机号" maxlength="11" v-model="phone"> </el-input>
            </div>
            <div class="code_cont">
                <el-input placeholder="请输入图形验证码" maxlength="4" v-model="imgCode">
                    <template slot="append">
                        <img v-throttle @click="getVerificationCode" :src="imgCodeUrl" alt="">
                    </template>
                </el-input>
            </div>
            <!-- <div :class="['phone_code', getNumFlag ? 'sendCode' : '']">
                <el-input placeholder="请输入短信验证码" maxlength="4" v-model="phoneCode">
                    <template slot="append">
                        <el-button v-throttle size="small" type="primary" :disabled="getNumFlag"
                            @click="getPhoneSecurityNum">
                            {{ getNumFlag ? getNumFlagTime + '秒后重试' : '获取验证码' }}
                        </el-button>
                    </template>
                </el-input>
            </div>
            <p class="sendTips" v-show="sendTipsFlag">已向手机尾号<span>{{ phoneLastNumber }}</span>发送验证码</p> -->
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="handleCancel">取 消</el-button>
                <el-button type="primary" v-throttle size="small" :disabled="submitDisable" @click="handleValiate">登
                    录</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import PageHead from '@/components/PageHead.vue'
import { getRandomImgCode } from '@/utils/util'
import { querySchoolbranchNotice, sendSms, teacherTelLogin, checkTel } from '@/request/application'
export default {
    components: {
        PageHead
    },
    data() {
        return {
            siteContent: '',//申请须知
            phoneVisible: false,
            phone: '',
            imgCode: '',
            rmCode: '',
            imgCodeUrl: '',
            getNumFlag: false,
            getNumFlagTime: 0,
            phoneLastNumber: '',
            phoneCode: '',
            timer: null,
            sendTipsFlag: false,
            submitDisable: false
        }
    },
    methods: {
        toInfoRegister() {
            this.$router.push({
                path: '/infoRegister'
            })
        },
        lookMore() {
            let noticeUrl = location.origin + location.pathname + '#/notice'
            window.open(noticeUrl, '_blank')
        },
        handleCancel() {
            this.imgCode = ''
            this.phoneCode = ''
            this.sendTipsFlag = false
            this.phoneVisible = false
            if (this.timer) {
                clearInterval(this.timer)
            }
        },
        handleValiate() {
            if (!this.phone) {
                this.$message.error({
                    message: '请输入手机号！',
                    icon: 'warning-o'
                })
                return false
            }
            if (!/^1[3456789]\d{9}$/.test(this.phone)) {
                this.$message.error({
                    message: '请输入正确的手机号！',
                    icon: 'warning-o'
                })
                return false
            }
            if (this.imgCode.length === 0) {
                this.$message.error({
                    message: '请输入图形验证码！',
                    icon: 'warning-o'
                })
                return false
            }
            // if (this.phoneCode.length === 0) {
            //     this.$message.error({
            //         message: '请输入短信验证码！',
            //         icon: 'warning-o'
            //     })
            //     return false
            // }
            checkTel({ v_tel: this.phone }).then(response => {
                if (response.success) {
                    this.submitDisable = true
                    let parm = {
                        v_code: this.imgCode,
                        rm: this.rmCode,
                        v_tel: this.phone
                    }
                    teacherTelLogin(parm).then(res => {
                        if (res.success) {
                            this.getNumFlag = false
                            if (this.timer) {
                                clearInterval(this.timer)
                            }
                            this.timer = null
                            this.$message.success(res.message)
                            this.handleCancel()
                            let newData = {
                                ...res.result[0],
                                token: res.token
                            }
                            this.$store.commit('setUser', newData)

                        }
                        this.submitDisable = false

                    }).catch(err => {
                         this.getVerificationCode()
                        this.submitDisable = false
                    })
                }
            }).catch(err => {  this.getVerificationCode()})

            // this.submitDisable = true
            // let parm = {
            //     v_code: this.phoneCode,
            //     v_tel: this.phone
            // }
            // teacherTelLogin(parm).then(res => {
            //     if (res.success) {
            //         this.getNumFlag = false
            //         if (this.timer) {
            //             clearInterval(this.timer)
            //         }
            //         this.timer = null
            //         this.$message.success(res.message)
            //         this.handleCancel()
            //         let newData = {
            //             ...res.result[0],
            //             token: res.token
            //         }
            //         this.$store.commit('setUser', newData)

            //     }
            //     this.submitDisable = false
            // }).catch(err => {
            //     this.submitDisable = false
            // })
        },
        handleLogin() {
            // this.phoneLastNumber = this.form.userPhone.substring(this.form.userPhone.length - 4, this.form.userPhone.length)
            this.phone = ''
            this.getVerificationCode()
            this.phoneVisible = true
        },
        getVerificationCode() {
            this.imgCode = ''
            const obj = getRandomImgCode()
            this.rmCode = obj.rmNum
            this.imgCodeUrl = obj.rmImgUrl
        },
        getPhoneSecurityNum() {
            if (!this.phone) {
                this.$message.error({
                    message: '请输入手机号！',
                    icon: 'warning-o'
                })
                return false
            }
            if (!/^1[3456789]\d{9}$/.test(this.phone)) {
                this.$message.error({
                    message: '请输入正确的手机号！',
                    icon: 'warning-o'
                })
                return false
            }
            if (this.imgCode.length === 0) {
                this.$message.error({
                    message: '请输入图形验证码！',
                    icon: 'warning-o'
                })
                return false
            }
            checkTel({ v_tel: this.phone }).then(response => {
                if (response.success) {
                    let parm = {
                        v_send_type: 6,
                        v_tel: this.phone,
                        v_code: this.imgCode,
                        rm: this.rmCode

                    }
                    sendSms(parm).then(res => {
                        if (res.success) {
                            this.getNumFlag = true // 用于禁用获取电话验证码按钮
                            this.getNumFlagTime = 60
                            this.timer = setInterval(() => { // 获取手机验证码成功提示
                                this.getNumFlagTime -= 1
                                if (this.getNumFlagTime === 0) {
                                    this.getNumFlag = false
                                    clearInterval(this.timer)
                                    this.timer = null
                                }
                            }, 1000)
                            this.phoneLastNumber = this.phone.substring(this.phone.length - 4, this.phone.length)
                            this.sendTipsFlag = true
                            this.$message.success('短信验证码已发送！')
                        } else {
                            this.getVerificationCode()
                        }
                    }).catch(err => {
                        this.getVerificationCode()
                    })
                }
            })

        },
        phoneInput(value) {
            value = value.replace(/[^0-9.]/g, '')
            this.$set(this, 'phone', value)
        },

    },
    created() {
        querySchoolbranchNotice().then(res => {
            if (res.success) {
                // this.siteContent = res.result[0].content;
                this.siteContent = res.result[0].content.replace(/<(?!\/?p|\/?br)[^<>]*>/ig, '');
            }
        })
        if (sessionStorage.getItem('userInfo')) {
            sessionStorage.removeItem('userInfo')
        }
    }
}
</script>
<style lang="less" scoped>
.home {
    height: 100%;

    .middle_content {
        width: 100%;
        height: calc(~"100% - 200px");
        min-height: 600px;
        background: url("../../assets/home/back.png") no-repeat 0 0;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .content {
            width: 1200px;
            height: 540px;
            display: flex;
            background: white;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

            .left {
                width: 701px;
                position: relative;
                padding: 39px 51px 0 40px;
                height: 100%;
                box-sizing: border-box;

                .progress_title {
                    font-size: 17px;
                    line-height: 1;
                    font-weight: 600;
                    padding-bottom: 29px;
                }

                .progress {
                    display: flex;
                    // align-items: center;
                    justify-content: space-around;

                    .item_progress {
                        text-align: center;

                        .img_icon {
                            font-size: 0;

                            img {
                                width: 60px;
                                height: 60px;
                            }

                            padding-bottom: 15px;
                        }

                        .desc {
                            font-size: 12px;
                            line-height: 1;
                            color: #333333;
                        }
                    }

                    .next_icon {
                        font-size: 19px;
                        color: #D4D4D4;
                        // width: 60px;
                        height: 60px;
                        line-height: 60px;
                        // text-align: center;
                    }
                }

                .divider {
                    margin-top: 51px;
                    margin-bottom: 38px;
                    width: 100%;
                    height: 1px;
                    background: #DDDDDD;
                }

                .need_word {
                    font-size: 17px;
                    line-height: 1;
                    font-weight: 600;
                    padding-bottom: 22px;
                }

                .word_desc::v-deep {
                    height: 60px;
                    font-size: 16px;
                    overflow: hidden;

                    * {
                        line-height: 20px !important;
                    }
                }

                .more {
                    color: #4A8EFF;
                    font-size: 15px;
                    line-height: 1;
                    padding-top: 20px;
                    cursor: pointer;
                    width: 100%;
                    text-align: right;
                }

                .right_split {
                    width: 1px;
                    height: 452px;
                    position: absolute;
                    top: 56px;
                    right: 0;
                }
            }

            .right {
                width: 499px;
                height: 100%;

                .door {
                    padding-top: 13px;
                    padding-bottom: 27px;
                    text-align: center;
                    font-size: 0;

                    img {
                        width: 422px;
                        height: 368px;
                    }
                }

                .register_btn,
                .login_btn {
                    cursor: pointer;
                    margin: auto;
                    width: 362px;
                    height: 42px;
                    background: #E34C38;
                    border-radius: 10px;
                    color: white;
                    font-size: 14px;
                    text-align: center;
                    line-height: 42px;
                }

                .login_btn {
                    background: #2D90EA;
                    margin-top: 16px;
                }
            }

        }
    }

    .footer {
        width: 100%;
        height: 100px;
        background: #ECECEC;
        text-align: center;

        div:first-child {
            padding: 26px 0 22px 0;
        }

        div {
            color: #333;
            font-size: 18px;
            line-height: 1;
        }
    }

    .code_cont {
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .phone_code {
        margin-bottom: 5px;

    }

    .sendCode ::v-deep {
        .el-button.is-disabled {
            background: #a0cfff;
            color: white;
        }

        .el-input-group__append {
            background: #a0cfff;
        }
    }

}
</style>